import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGetExperiment } from '../../../../experiments/hooks'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION } from '../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../experiments/model/EXPERIMENT_VARIATION'
import { ProductSellerPromotionFlag } from '../../../../product'
import { productSearchAlgoliaAccessorGetBestOfferSellerPromotion } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetBestOfferSellerPromotion'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'

type ProductSearchResultItemSellerPromotionLabelProps = { className?: string }

export const ProductSearchResultItemSellerPromotionLabel: FC<
  ProductSearchResultItemSellerPromotionLabelProps
> = ({ className }) => {
  const isMarketplaceHarmonisationEnabled =
    useGetExperiment(EXPERIMENT_NAME_MARKETPLACE_HARMONISATION).variant ===
    EXPERIMENT_VARIATION.V1

  const { algoliaRecord } = useProductSearchResultItemContext()

  const sellerPromotion =
    productSearchAlgoliaAccessorGetBestOfferSellerPromotion(algoliaRecord)

  if (!sellerPromotion) {
    return null
  }

  return (
    <ProductSearchResultItemGenericLabel
      className={clsx(
        isMarketplaceHarmonisationEnabled
          ? 'border-none bg-light-tertiary'
          : 'border-light-primary-strong bg-light-primary-medium',
        className,
      )}
      data-qa-id="serp-has-best-offer-seller-promotion-label"
    >
      {isMarketplaceHarmonisationEnabled ? (
        <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
      ) : (
        <FormattedMessage id="seller.promotion.product.badge" />
      )}
    </ProductSearchResultItemGenericLabel>
  )
}
